import { getCurrentCsrfToken } from "common/utils/csrf-token-manager";

const parseResponse = (response, errorMessage) => {
  if (response.status === 304) return null;
  if (!response.ok) throw new Error(errorMessage);
  return response.json();
};

const buildQueueUrl = (basePath, state) => {
  const params = new URLSearchParams({
    date: state.date,
    page: state.page,
    per_page: state.perPage,
    last_updated: state.lastUpdated,
    status: state.status
  });

  return `${basePath}.json?${params.toString()}`;
};

const buildSignalsUrl = (shipmentId, signalId = null) =>
  `/supplier/shipments/${shipmentId}/signals${signalId ? `/${signalId}` : ""}`;

const csrfHeaders = () => ({
  "X-CSRF-Token": getCurrentCsrfToken(),
  Accept: "application/json"
});

const requestQueue = (basePath, state, errorMessage) =>
  fetch(buildQueueUrl(basePath, state), { headers: { Accept: "application/json" } }).then(
    response => parseResponse(response, errorMessage)
  );

const requestSignal = ({ shipmentId, signalType, errorMessage = "Signal request failed." }) =>
  fetch(buildSignalsUrl(shipmentId), {
    method: "POST",
    headers: { "Content-Type": "application/json", ...csrfHeaders() },
    credentials: "same-origin",
    body: JSON.stringify({ signal_type: signalType })
  }).then(response => parseResponse(response, errorMessage));

const undoSignal = ({ shipmentId, signalId, errorMessage = "Undo signal request failed." }) =>
  fetch(buildSignalsUrl(shipmentId, signalId), {
    method: "DELETE",
    headers: csrfHeaders(),
    credentials: "same-origin"
  }).then(response => parseResponse(response, errorMessage));

export { parseResponse, buildQueueUrl, csrfHeaders, requestQueue, requestSignal, undoSignal };
